import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as form from "../form";
import * as listbox from "../listbox";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";
import * as grid from "../grid";

var _msg_notsaved = "";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NodeTypeGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationNodeType/Show?nodeTypeId=" + dataItem.N_TypeID + "&breadcrumbLabel=" + dataItem.Name);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NodeTypeGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationNodeType/Edit?nodeTypeId=" + dataItem.N_TypeID + "&breadcrumbLabel=" + dataItem.Name);
}

export function childrenItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NodeTypeGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationNodeType/Children_NodeType?nodeTypeId=" + dataItem.N_TypeID + "&breadcrumbLabel=" + dataItem.Name);
}

export function adaptItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NodeTypeGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationNodeType/Adapt?nodeTypeId=" + dataItem.N_TypeID + "&breadcrumbLabel=" + dataItem.Name);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this as kendo.ui.Grid;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as NodeTypeGridVM;
        removeItem(dataItem.N_TypeID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function removeItem(nodeTypeId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationNodeType/Delete"),
        data: {
            nodeTypeId: nodeTypeId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("NodeTypesGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}


//--- LR ------------------------------------------------------------//

export function lr_initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Return label changed not saved
*/
export function lr_ldataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

export function enableSaveButton(): void {
    const saveButton = $("#SaveButton");

    if (saveButton.length > 0) {
        saveButton.data("kendoButton").enable(true);
    }
}

export function disableSaveButton(): void {
    const saveButton = $("#SaveButton");

    if (saveButton.length > 0) {
        saveButton.data("kendoButton").enable(false);
    }
}

export function lr_rightClicked(): void {
    enableSaveButton();
    listbox.moveItems("Items_CplNotSelected", "Items_CplSelected", "#LR_Validation", lr_ldataChangedNotSavedYet());
}

export function lr_leftClicked(): void {
    enableSaveButton();
    listbox.moveItems("Items_CplSelected", "Items_CplNotSelected", "#LR_Validation", lr_ldataChangedNotSavedYet());
}

export function onSaveButtonClicked(Id: number, menuId: number): void {

    const list = JSON.stringify($("#Items_CplSelected").data("kendoListBox").dataItems());
    let url = 'AdministrationNodeType/SaveModulesNodeTypes';

    $.ajax({
        type: "POST",
        data:
        {
            Id: Id,
            assigned: list
        },
        url: appsettings.getUrl(url),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != null && responseData != undefined) {
                form.showServerResponse("LRShowResponse", responseData, function () { });

                if (responseData.Succesfully) {
                    disableSaveButton();
                }
            }

            $("#partial_First").load(appsettings.getUrl("AdministrationNodeType/First_NodeTypes?nodeTypeId=" + Id));
        }
    });
}

export function nodeTypeRadio_clicked(e: kendo.ui.RadioGroupChangeEvent): void {

    const nodeTypeId = $("#NodeTypeID").val();
    const moduleId = e.sender.options.value;

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationNodeType/SetFirst"),
        data: {
            nodeTypeId: nodeTypeId,
            moduleId: moduleId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            /*administration.refreshGrid("NodeTypesChildrenGrid");*/

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}

export function children_initialize(parentNodeTypeId: number): void {

    // Create new record ...
    $(".k-grid-add").on("click", function (e) {

        // Prevent default behaviour
        e.preventDefault();

        // Load create form into the current module div
        navigation.navigateToSpecificUrl("AdministrationNodeType/Add_Children?parentNodeTypeId=" + parentNodeTypeId);
    });
}

export function nodeTypeChildren_deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this as kendo.ui.Grid;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const parentId = Number($("#Parent_NodeTypeID").val());
        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as NodeTypeChildVM;
        nodeTypeChildren_removeItem(parentId, dataItem.N_TypeID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function nodeTypeChildren_removeItem(parentId: number, childId: number): void {

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationNodeType/DeleteChild"),
        data: {
            parentId: parentId,
            childId: childId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("NodeTypesChildrenGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}